import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// Register GSAP ScrollTrigger globally here
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Activate plugin
gsap.registerPlugin(ScrollTrigger);

// Mount the app
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
